import {
    map,
    camelCase,
    filter,
    reduce,
    get,
    kebabCase
} from 'lodash-es'

import {
    remove
} from 'diacritics'

const getTaxonomyValue = taxonomy => (value, identifier = 'value') => get(taxonomy, [value, '0', identifier]);

const getPrice = (t) => {
    const getValue = getTaxonomyValue(t);
    switch (getValue('langcode')) {
        case 'fi':
        case 'en':
            return Number(getValue('field_fi_svh_24'));
        case 'no':
            return Number(getValue('field_no_svh_25'));
        case 'se':
            return Number(getValue('field_se_svh_25'));
        default:
            return 0;
    }
};

export const propertyClassName = name => kebabCase(remove(name));

export const parseDrupalJSON = (accessories, boat) => {
    const state = {};
    const selections = {};
    map(accessories, t => {
        const getValue = getTaxonomyValue(t);
        const category = camelCase(getValue('vid', 'target_id'));
        if (category) {
            if (!state[category]) {
                state[category] = {
                    title: category,
                    options: []
                };
                selections[category] = [];
            }
            const price = getPrice(t);
            const id = getValue('tid');
            state[category].options.push({
                id,
                description: getValue('name'),
                price
            });
            if (!price) {
                selections[category].push(id);
            }
        }
    });
    return {
        ...state,
        selections,
        boat,
    };
};

export const getElementDataAttributes = element => reduce(
    filter(element.attributes, a => /^data-/.test(a.name)), (result, attribute) => {
        result[camelCase(attribute.name.substr('data-'.length))] = attribute.value;
        return result;
    }, {}
);

export const getPropertyState = (state, props) => {
    const {property} = props;
    const {selections, currency} = state;
    if (!property || !state[property] || !selections[property]) {
        throw new Error(`Invalid property ${property}`);
    }
    return {
        currency,
        title: state[property].title,
        items: state[property].options,
        selections: selections[property],
    }
};


// WEBPACK FOOTER //
// ./src/utils/parsers.js